'use client';

import { cn } from '@/lib/utils';
import { Skeleton } from '../Skeleton';

/*
 * A Suspense fallback for server pages. It is a client component on purpose: a server-side
 * Skeleton.Group would call next-intl's request-bound useTranslations while the page renders and
 * read the request headers, which makes a page dynamic. The root layout already does that today,
 * so this keeps the rule for the day it stops. Here the client provider supplies the label.
 */
export function SuspenseSkeleton({ className }: { className?: string }) {
  return (
    <Skeleton.Group>
      <Skeleton className={cn('h-96 rounded-lg', className)} />
    </Skeleton.Group>
  );
}
